import { createAsyncApiAction } from '@cbgms/base/redux/create-async-action'
import {
  ITenderEngineAvailabilityRequest,
  ITenderEngineFluidsPayload,
  ITenderEngineHoliday,
  ITenderEngineInformation,
  ITenderEngineRates
} from './index'

export const getTenderEngineProfile = (conceptUUID: string) => ({
  url: `/integration/tenderengine/${conceptUUID}/shopinfo`,
  method: 'GET'
})

export const updateTenderEngineProfileRequest = (conceptUUID: string, data: ITenderEngineInformation) => ({
  url: `/integration/tenderengine/${conceptUUID}/shopinfo`,
  method: 'PUT',
  data
})

export const getTenderEngineRates = (conceptUUID: string) => ({
  url: `/integration/tenderengine/${conceptUUID}/rates`,
  method: 'GET'
})

export const updateTenderEngineRatesRequest = (conceptUUID: string, data: ITenderEngineRates) => ({
  url: `/integration/tenderengine/${conceptUUID}/rates`,
  method: 'PUT',
  data
})

export const getTenderEngineHolidayRequest = (conceptUUID: string, params: ITenderEngineAvailabilityRequest) => ({
  url: `/integration/tenderengine/${conceptUUID}/holidays`,
  method: 'GET',
  params
})

export const createTenderEngineHolidayRequest = (conceptUUID: string, data: ITenderEngineHoliday) => ({
  url: `/integration/tenderengine/${conceptUUID}/holidays`,
  method: 'POST',
  data
})

export const deleteTenderEngineHolidayRequest = (tenderEngineWorkshopID: string, holidayUUID: string) => ({
  url: `/integration/tenderengine/${tenderEngineWorkshopID}/holidays/${holidayUUID}`,
  method: 'DELETE'
})

export const getTenderEngineFluids = (tenderEngineWorkshopID: string) => ({
  url: `/integration/tenderengine/${tenderEngineWorkshopID}/fluids`,
  method: 'GET'
})

export const updateTenderEngineFluids = (tenderEngineWorkshopID: string, data: ITenderEngineFluidsPayload) => ({
  url: `/integration/tenderengine/${tenderEngineWorkshopID}/fluids`,
  method: 'PUT',
  data
})

export const getTenderEngineShopInfo = (shopReferenceUUID: string, conceptUUID: string) => ({
  url: `/modules/integration/tenderengine/${shopReferenceUUID}/${conceptUUID}/shopinfo`,
  method: 'GET'
})

export const getTenderRequest = (tenderID: string) => ({
  url: `/integration/tenderengine/tender/${tenderID}`,
  method: 'GET'
})

export const getTenderAppointmentRequest = (orderID: string) => ({
  url: `/integration/tenderengine/appointments/${orderID}`,
  method: 'GET'
})

export const getTenderAppointmentsRequest = () => ({
  url: `/integration/tenderengine/appointments`,
  method: 'GET'
})

export const getTenderEnginePlanningSourceOptions = (conceptUUID: string) => ({
  url: `/integration/tenderengine/${conceptUUID}/planning-setting-options`,
  method: 'GET'
})

export const getTenderProposalPdf = (tenderCode: string) =>
  createAsyncApiAction<Blob>('gms', {
    method: 'GET',
    url: `/integration/tenderengine/tender/${tenderCode}/pdf`
  })
